import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RangeMixin } from '../../mixins/components/RangeMixin';
/**
 * A native "range" input, also commonly known as a slider.
 * For more documentation about range inputs:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range
 *
 * See also [`Slider`](#/Form%20components?id=slider), a more full
 * featured implementation of a slider.
 *
 * @since 6.11.0
 */

var Range = /*#__PURE__*/styled.input.attrs({
  type: 'range'
}).withConfig({
  displayName: "Range",
  componentId: "c11n-8-64-0__sc-afacwm-0"
})(["", ""], RangeMixin);
Range.propTypes = {
  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#max */
  max: PropTypes.string.isRequired,

  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#min */
  min: PropTypes.string.isRequired,

  /** https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/range#step */
  step: PropTypes.string
};
Range.defaultProps = {
  step: '1'
};
/** @component */

export default Range;
export var StyledRange = Range;